<unity-dropdown-clickable-control
  sortBy="name"
  textField="name"
  linkRoot="/form-type"
  [selectable]="$selectable()"
  [control]="$control()"
  [displayName]="$displayName()"
  [description]="$description()" />
